import {faCircleInfo} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {ReactNode} from 'react';

import * as styles from './inline-banner.scss';

type PropsType = {
    title: ReactNode;
    description: ReactNode;
};

export function InlineBanner(props: PropsType): JSX.Element {
    const {title, description} = props;

    return (
        <div className={styles.InlineBanner}>
            <FontAwesomeIcon className={styles.InlineBanner_icon} icon={faCircleInfo} />
            <div className={styles.InlineBanner_content}>
                <p className={styles.InlineBanner_title}>{title}</p>
                <p className={styles.InlineBanner_description}>{description}</p>
            </div>
        </div>
    );
}
